import { render, staticRenderFns } from "./LegalNav.vue?vue&type=template&id=9d086278&scoped=true"
import script from "./LegalNav.vue?vue&type=script&lang=js"
export * from "./LegalNav.vue?vue&type=script&lang=js"
import style0 from "./LegalNav.vue?vue&type=style&index=0&id=9d086278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d086278",
  null
  
)

export default component.exports